import api from './api'
import { API_ENDPOINTS } from '../config/api'

// Helper function to check if user is owner by user ID
const isOwnerByUserId = (userId) => {
  if (!userId) return false
  // Check if user ID indicates owner (you can customize this logic)
  // Common patterns: owner IDs might be specific numbers or have 'owner' in them
  const ownerUserIds = ['1', 1, 'owner', 'diamond_owner', 'diamond99_owner']
  const userIdStr = String(userId).toLowerCase()
  return ownerUserIds.some(id => userIdStr === String(id).toLowerCase() || userIdStr.includes('owner'))
}

// Helper function to check if credentials indicate owner
const isOwnerByCredentials = (credentials) => {
  // Check by user ID if provided
  if (credentials.user_id || credentials.id) {
    return isOwnerByUserId(credentials.user_id || credentials.id)
  }
  // Check by email/username (existing logic)
  const identifier = credentials.email || credentials.username
  if (identifier && identifier.toLowerCase().includes('owner')) {
    return true
  }



}

export const authService = {
  // Unified login that automatically routes to owner login if owner detected
  login: async (credentials) => {
    // Check if user is owner by user ID or credentials
    const isOwner = isOwnerByCredentials(credentials)

    if (isOwner) {
      // Always use owner login endpoint for owner users
      return await authService.ownerLogin(credentials)
    } else {
      // Use regular staff login endpoint
      const response = await api.post(API_ENDPOINTS.AUTH.LOGIN, credentials)
      return response.data
    }
  },

  logout: async () => {
    const response = await api.post(API_ENDPOINTS.AUTH.LOGOUT)
    return response.data
  },

  refreshToken: async () => {
    const response = await api.post(API_ENDPOINTS.AUTH.REFRESH)
    return response.data
  },

  getProfile: async () => {
    // First, check if current user is owner and use owner profile endpoint
    const storedUser = localStorage.getItem('user')
    const activeRole = localStorage.getItem('activeRole')

    // Check by activeRole first
    if (activeRole === 'owner') {
      return await authService.getOwnerProfile();
    } else if (activeRole) {
      // Explicitly for ANY non-owner role (staff, admin, master, etc.), 
      // do NOT check isOwnerByUserId to avoid false positives for staff with ID=1
      const response = await api.get(API_ENDPOINTS.USER.PROFILE)
      return response.data
    }

    // Check by user ID if available - try owner profile first
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser)
        if (isOwnerByUserId(user.id) || isOwnerByUserId(user.user_id) || isOwnerByUserId(user.owner_id)) {
          return await authService.getOwnerProfile()
        }
      } catch (e) {
        // If parsing fails, continue with regular profile
      }
    }

    // Fallback to staff profile
    const response = await api.get(API_ENDPOINTS.USER.PROFILE)
    return response.data
  },

  ownerLogin: async (credentials) => {
    const response = await api.post(API_ENDPOINTS.AUTH.OWNER_LOGIN, credentials)
    return response.data
  },

  verify2FA: async (id, otp, isOwner = false) => {
    // Use owner endpoint if isOwner is true, otherwise use staff endpoint
    const endpoint = isOwner ? '/admin/owner/verify-2fa' : '/admin/staff/verify-2fa';
    const body = isOwner ? { ownerId: id, otp } : { staffId: id, otp };
    const response = await api.post(endpoint, body);
    return response.data;
  },

  getOwnerProfile: async () => {
    const response = await api.get(API_ENDPOINTS.USER.OWNER_PROFILE)
    return response.data
  },

}

